import { action, atom } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { delugeIdAtom } from '@root/entities/auth'
import { UnknownError } from '@root/shared'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui/error-snackbar'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { reportRequestAction } from './report-requests'

import type { Socials } from '@root/entities/socials'

type ReportTelegramGroupPayload = {
  readonly reason: string
  readonly additionalInformation?: string
}

export const reatomReportTelegramGroupForm = ({
  groupInfo,
}: {
  groupInfo: Socials.TgInfo
}) => {
  const executeAction = action(
    async (ctx, args: ReportTelegramGroupPayload) => {
      const delugeId = ctx.get(delugeIdAtom)

      if (!delugeId) {
        return Result.fail(UnknownError.fromUnknown('no delugeId'))
      }

      return reportRequestAction(ctx, {
        entity: 'telegram_group',
        reason: args.reason,
        additionalInfo: args.additionalInformation,
        target: {
          portalLink: groupInfo.portalLink,
        },
        fromDelugeId: delugeId,
      })
    },
    'executeAction',
  )

  // eslint-disable-next-line @reatom/unit-naming-rule
  const theAtom = reatomRequest({
    execAction: executeAction,
    onResult(ctx, result) {
      Result.match(result, {
        onFailure: (error) => showErrorSnackbarAction(ctx, error),
        onSuccess: () =>
          showSnackbarAction(ctx, {
            text: i18next.t('report.report-telegram-group-success'),
            intent: 'success',
          }),
      })
    },
  })

  return theAtom
}

export const activeReportingTelegramGroupAtom = atom<
  Socials.TgInfo | undefined
>(undefined, 'activeReportingTelegramGroupAtom')

export const showReportTelegramGroupDialogAction = action(
  (ctx, groupInfo: Socials.TgInfo) => {
    activeReportingTelegramGroupAtom(ctx, groupInfo)
  },
  'showReportTelegramGroupDialogAction',
)
